export function formatDuration(value) {
  const minute = Math.floor(value / 60);
  const secondLeft = value - minute * 60;
  if (value < 0 || !value || isNaN(value) || value === Infinity) {
    return '00:00';
  }

  return `${minute < 10 ? `0${minute}` : minute}:${secondLeft < 10 ? `0${secondLeft}` : secondLeft}`;
}
